import { TranslateService } from '@ngx-translate/core';

import {
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

import { foldedDayLabel } from './booking-diary.weekend';

// The chevron that folds a weekend day to a narrow column and opens it again
@Component({
  selector   : 'wor-booking-diary-fold-toggle',
  template: require('./booking-diary.fold-toggle.component.html')
})
export class BookingDiaryFoldToggleComponent {
  @Input() isFolded : boolean = false;
  @Input() label    : string  = '';

  @Output() toggled : EventEmitter<void> = new EventEmitter<void>();

  constructor (
    private translateService : TranslateService
  ) {}

  // the toggle sits in a clickable heading, so its click must not also open the day
  onClick ( clickEvent : MouseEvent ) : void {
    clickEvent.preventDefault();
    clickEvent.stopPropagation();

    this.toggled.emit();
  }

  get title () : string {
    return this.translateService.instant(this.isFolded
      ? 'BOOKING_SPACE.DIARY.UNFOLD_DAY'
      : 'BOOKING_SPACE.DIARY.FOLD_DAY', { day: foldedDayLabel(this.label) });
  }
}
